export const OrderTypes = {
  SALES: 1,
  REPLENISH: 2,
  EXPENSES: 3,
  INVESTMENT: 4,
  labels: {
    1: 'продажа',
    2: 'пополнение',
    3: 'расход',
    4: 'инвестиция',
  },
}

export function getOrderTypeId(order) {
  const n = Number.parseInt(String(order?.typeId ?? order?.type_id ?? ''), 10)
  return Number.isFinite(n) ? n : OrderTypes.SALES
}

export function isSalesOrder(order) {
  return getOrderTypeId(order) === OrderTypes.SALES
}

export function isReplenishOrder(order) {
  return getOrderTypeId(order) === OrderTypes.REPLENISH
}

export function isExpenseOrder(order) {
  return getOrderTypeId(order) === OrderTypes.EXPENSES
}

export function isInvestmentOrder(order) {
  return getOrderTypeId(order) === OrderTypes.INVESTMENT
}
